module.exports = "https://static.im-cdn.com/mjc/storefront/Compass/static/media/Sort.ce29f08b.svg";